import { i18n } from '@/i18n';
import { PAGE_URL } from '.';

// 中转页链接
export const REDIRECT_URL = 'https://prom.wechatpay.com.hk/discount-code-thirdapp/index.shtml?confId=channel';

// 分享面板内容
export const SHARE_ENTRY_INFO = {
  title: i18n('分享畀朋友'),
  description: '',
};

/** 分享类型 */
export enum ShareConfigType {
  wx = 'wx',
  copy = 'copy',
  mp = 'mp'
}

/** 微信分享adtag */
const SHARE_WX_ADTAG = 'c_h5';
/** 复制分享adtag */
const SHARE_COPY_ADTAG = 'c_copy';
/** 小程序分享adtag */
const SHARE_MP_ADTAG = 'c_mp';

/** 分享ADTAG配置 */
export const SHARE_CONFIG: Record<ShareConfigType, {adtag: string, link: string}> = {
  wx: { adtag: SHARE_WX_ADTAG, link: PAGE_URL },
  copy: { adtag: SHARE_COPY_ADTAG, link: REDIRECT_URL },
  mp: { adtag: SHARE_MP_ADTAG, link: PAGE_URL },
};
